import type { BaseSelectionResponse } from "@frend-digital/centra-types/selection";
import type { IngridError } from "../errors";
import type { PaymentError, PaymentInitError } from "../providers";

export type PaymentErrorAction = {
  type: "PAYMENT_ERROR";
  payload: PaymentError;
};

export type AddressErrorAction = {
  type: "ADDRESS_ERROR";
  payload: any; // TODO - add errors type
};

export type IngridErrorAction = {
  type: "INGRID_ERROR";
  payload: IngridError;
};

export type PaymentInitErrorAction = {
  type: "PAYMENT_INIT_ERROR";
  payload: PaymentInitError;
};

export type ResetErrorAction = {
  type: "RESET_ERROR";
};

export const SelectionChangeReason = {
  Address: "address",
  ShippingMethod: "shipping_method",
  Ingrid: "ingrid",
  RegionChange: "region_change",
} as const;
export type SelectionChangeReason =
  (typeof SelectionChangeReason)[keyof typeof SelectionChangeReason];

export type SelectionChangeAction = {
  type: "SELECTION_CHANGE";
  payload: BaseSelectionResponse;
  reason: SelectionChangeReason;
};

export type Action =
  | PaymentErrorAction
  | AddressErrorAction
  | IngridErrorAction
  | PaymentInitErrorAction
  | ResetErrorAction
  | SelectionChangeAction;

// Action creators

export const resetCheckoutError = (): ResetErrorAction => ({
  type: "RESET_ERROR",
});

export const selectionChange = (
  selection: BaseSelectionResponse,
  reason: SelectionChangeReason
): SelectionChangeAction => ({
  type: "SELECTION_CHANGE",
  payload: selection,
  reason,
});
